import {
  CourseTagsState,
  CourseTagsActionTypes,
  COURSE_TAGS_REQUEST,
  COURSE_TAGS_SUCCESS,
  COURSE_TAGS_FAILURE,
} from "./types";

/**
 * Initial state for the course tags reducer.
 */
const initialState: CourseTagsState = {
  courseTags: [],
  isLoading: false,
  error: false,
};

/**
 * Reducer handling course tags state changes.
 *
 * Manages course tags data, loading state, and error state
 * based on dispatched actions.
 *
 * @param state - Current course tags state.
 * @param action - Action dispatched to update the state.
 * @returns Updated state after applying the action.
 */
export const courseTagsReducer = (
  state = initialState,
  action: CourseTagsActionTypes
): CourseTagsState => {
  switch (action.type) {
    case COURSE_TAGS_REQUEST:
      return { ...state, isLoading: true, error: false };
    case COURSE_TAGS_SUCCESS:
      return {
        ...state,
        courseTags: action.data,
        isLoading: false,
        error: false,
      };
    case COURSE_TAGS_FAILURE:
      return { ...state, isLoading: false, error: true };
    default:
      return state;
  }
};
